<template>
  <div class="modal fade" id="withdrawalConfirmationModal" tabindex="-1" role="dialog" aria-labelledby="withdrawalConfirmationModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="withdrawalConfirmationModalLabel">Confirm Withdrawal</h5>
          <button type="button" class="close" @click="closeModal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="alert alert-warning">
            <i class="fa fa-exclamation-triangle" style="margin-right: 0.5rem;"></i>
            Please confirm you are withdrawing to the correct bank account.
          </div>

          <p class="mb-3">
            You are about to withdraw <strong>${{ withdrawalAmount }}</strong> to your bank account ending in <strong>{{ accountLast4 }}</strong>.
          </p>

          <p class="text-muted small">
            If this is the wrong bank account, please send an email to <a href="mailto:help@peerstreet.com">help@peerstreet.com</a> to change it.
          </p>

          <div class="form-group">
            <label for="confirmLast4">Please enter the last 4 digits of your bank account to confirm:</label>
            <input
              type="text"
              class="form-control form-control-lg text-center"
              id="confirmLast4"
              v-model="enteredLast4"
              @input="validateInput"
              maxlength="4"
              pattern="[0-9]*"
              placeholder="XXXX"
              autocomplete="off"
              :class="{ 'is-invalid': showError }"
              :style="{ fontSize: '1.5rem', letterSpacing: '0.5rem', fontWeight: 'bold' }"
            >
            <div class="invalid-feedback" v-if="showError">
              The last 4 digits do not match. Please try again.
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeModal">Cancel</button>
          <button
            type="button"
            class="btn btn-primary"
            @click="confirmWithdrawal"
            :disabled="!isValid"
          >
            Confirm Withdrawal
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WithdrawalConfirmationModal',

  props: {
    accountLast4: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      enteredLast4: '',
      showError: false,
      originalForm: null,
      withdrawalAmount: '0.00'
    }
  },

  computed: {
    isValid() {
      return this.enteredLast4.length === 4 && this.enteredLast4 === this.accountLast4;
    }
  },

  methods: {
    validateInput() {
      // Only allow numbers
      this.enteredLast4 = this.enteredLast4.replace(/[^0-9]/g, '');

      // Show error if they've entered 4 digits and they don't match
      if (this.enteredLast4.length === 4 && this.enteredLast4 !== this.accountLast4) {
        this.showError = true;
      } else {
        this.showError = false;
      }
    },

    openModal(form) {
      this.originalForm = form;
      this.enteredLast4 = '';
      this.showError = false;

      // Get the withdrawal amount from the form
      const amountInput = document.getElementById('withdrawal-amount');
      if (amountInput) {
        this.withdrawalAmount = amountInput.value || '0.00';
      }

      $('#withdrawalConfirmationModal').modal('show');
    },

    closeModal() {
      $('#withdrawalConfirmationModal').modal('hide');
      this.enteredLast4 = '';
      this.showError = false;
    },

    confirmWithdrawal() {
      if (this.isValid && this.originalForm) {
        // Close modal
        this.closeModal();

        // Submit the original form
        // Remove our event listener to prevent infinite loop
        this.originalForm.removeEventListener('submit', this.handleFormSubmit);
        this.originalForm.submit();
      }
    },

    handleFormSubmit(e) {
      e.preventDefault();
      this.openModal(e.target);
    }
  },

  mounted() {
    // Find the withdrawal form and attach our handler
    const withdrawalForm = document.querySelector('.withdrawal-form');
    if (withdrawalForm) {
      this.handleFormSubmit = this.handleFormSubmit.bind(this);
      withdrawalForm.addEventListener('submit', this.handleFormSubmit);
    }
  },

  beforeDestroy() {
    // Clean up event listener
    const withdrawalForm = document.querySelector('.withdrawal-form');
    if (withdrawalForm) {
      withdrawalForm.removeEventListener('submit', this.handleFormSubmit);
    }
  }
}
</script>

